import {
  Box,
  Button,
  Card,
  IconButton,
  makeStyles,
  Modal,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { ReportProblem, Close } from "@material-ui/icons";
import React from "react";
import { gpColors } from "../../constants/colors";
const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  modalCard: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 370,
    // height: 400,
    backgroundColor: "#fff",
    border: "1px",
    borderRadius: "15px",
    textAlign: "center",
  },
}));

function AddProductValMOdal(props) {
  const classes = useStyles();

  return (
    <div>
      {/* Form Validation Modal */}
      <Modal open={props.validationModal}>
        <Card className={classes.modalCard}>
          <Box sx={{ color: "#CA0B00", margin: 2 }}>
            <ReportProblem style={{ fontSize: "70px" }} />
          </Box>
          <Typography style={{ margin: 3 }}>
            All the fields are mandatory.
          </Typography>
          <Button
            type="submit"
            className={classes.button}
            style={{ margin: "10px" }}
            onClick={() => props.closeValidationModal()}
          >
            Try Again
          </Button>
        </Card>
      </Modal>

      {/* alert for data successfully saved to DB */}
      <Snackbar
        ContentProps={{
          style: { background: props.alert.alertColor },
        }}
        open={props.alert.alertStatus}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => {
          props.handleAlertClose();
        }}
        message={props.alert.alertMessage}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => props.handleAlertClose()}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      />
    </div>
  );
}

export default AddProductValMOdal;
